
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { apiurl } from '../../utils/constants';
import { fCurr } from '../../utils/functions';

const MAX_COMMENTS_LENGTH = 254;

function ExpoBillSap({ idForm, onClose}) {
	const [invoice, setInvoice] = useState(null);
	const [loading, setLoading] = useState(true);
	const [showOrderDialog, setShowOrderDialog] = useState(false);
	const [selectedOrderOptions, setSelectedOrderOptions] = useState([]);
	const [tableData, setTableData] = useState({
		ingresado: '',
		vencimiento: '',
		proveedor: '',
		factura: '',
		total: 0,
		impuesto: 0,
		ordenCompra: '',
		reqAprobacion: '',
		comments: ''
	});
	const [serviciosData, setServiciosData] = useState([]);
	const [productosData, setProductosData] = useState([]);
	const [checkedServicios, setCheckedServicios] = useState([]);
	const [checkedProductos, setCheckedProductos] = useState([]);
	const [purchaseOrders, setPurchaseOrders] = useState([]);
	const [isSending, setIsSending] = useState(false);
	const [sinOCInputsValidation, setSinOCInputsValidation] = useState([])
	const [lineasSinOCForm, setLineasSinOCForm] = useState([]);
	const [commentsFromOc, setCommentsFromOc] = useState([]);
	const [total, setTotal] = useState(0);
	const [itemsFromXML, setItemsFromXML] = useState([]);
	const now = useRef(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().slice(0, 16));

	const { mail, sapDB } = useSelector((state) => state.user);

	const formatDateTimeForInput = useCallback((value) => {
		if (!value) return '';
		const strValue = String(value);
		const match = strValue.match(/^(\d{4}-\d{2}-\d{2})[T\s](\d{2}:\d{2})/);
		if (match) return `${match[1]}T${match[2]}`;

		const date = new Date(strValue);
		if (Number.isNaN(date.getTime())) return '';

		const pad = (num) => String(num).padStart(2, '0');
		return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
	}, []);

	const loadPurchaseOrdersByCardCode = useCallback(async (cardCode) => {
		if (!String(cardCode ?? '').trim()) return;
		try {
			const response = await fetch(apiurl + 'purchaseOrdersByCardCode', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					sapDB,
					cardCode: String(cardCode).trim(),
				}),
			});
			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}
			const result = await response.json();
			const orders = (result.data || []).map((item) => ({
				docNum: item.DocNum,
				date: item.DocDate,
				total: item.DocTotal,
				CardName: item.CardName,
				emCount: item.EMCount,
				lineCount: item.lineCount,
				emTotal: item.Total,
				from: item.From,
				netoTotal: item.NetoTotal,
				paymentTerm: item.PaymentTerm,
			}));
			setPurchaseOrders(orders);
		} catch (error) {
			console.error('Error fetching purchase orders by card code:', error);
		}
	}, [mail, sapDB]);

	const loadInvoice = useCallback(async () => {
		try {
			setLoading(true);
			const response = await fetch(apiurl + `invoices`, {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					sapDB, user: mail, iden_form: idForm
				})
			});

			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}
			const data = await response.json();
			const invoiceData = Array.isArray(data) ? data[0] : data;
			setInvoice(invoiceData);

			if (invoiceData) {
				const today = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString()
				setTableData({
					ingresado: invoiceData.DocDate ? formatDateTimeForInput(invoiceData.DocDate) : formatDateTimeForInput(today),
					vencimiento: invoiceData.DocDueDate ? invoiceData.DocDueDate.slice(0, 10) : '',
					proveedor: invoiceData.CardCode || '',
					factura: invoiceData.FolioPref + "-" + invoiceData.FolioNum,
					total: invoiceData.DocTotal || 0,
					impuesto: invoiceData.VatSum || 0,
					ordenCompra: invoiceData.order || '',
					reqAprobacion: invoiceData.approver ? 'Y' : 'N',
					comments: invoiceData.Comments || '',
					contabilizado: now.current
				});
				await loadPurchaseOrdersByCardCode(invoiceData.CardCode);
			}
		} catch (error) {
			console.error('Error fetching invoice:', error);
		} finally {
			setLoading(false);
		}
	}, [idForm, loadPurchaseOrdersByCardCode, mail, sapDB, formatDateTimeForInput]);

	useEffect(()=>{
		const servicios = checkedServicios.map((serv) => Number(serv.cantidad) * Number(serv.costoNeto || 0)).reduce((acc, val) => acc + val, 0)
		const productos = checkedProductos.map((serv) => Number(serv.cantidad) * Number(serv.costoNeto || 0)).reduce((acc, val) => acc + val, 0)
		console.log({prod: productos, checkedProductos})

		const sinOc = lineasSinOCForm ? lineasSinOCForm.reduce((acc, linea) => acc + (Number(linea.cantidad) * Number(linea.costoNeto || 0)), 0) : 0

		setTotal(servicios + productos + sinOc)
	}, [checkedServicios, checkedProductos, lineasSinOCForm])

	const updateInvoiceField = useCallback(async (fieldName, rawValue) => {
		const safeValue = fieldName === '`order`' ? 
			rawValue.length === 0 ? "" :	JSON.stringify(rawValue) 
		:
		String(rawValue ?? '').replace(/'/g, "''");

		const response = await fetch(apiurl + 'tablePUT', {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				user: mail,
				table: 'bil__form',
				fields: `${fieldName}=${safeValue === "" ? null : `'${safeValue}'`}`,
				iden: `iden=${idForm}`,
			}),
		});

		if (!response.ok) {
			throw new Error(`Error: ${response.status} ${response.statusText}`);
		}

		return response.json();
	}, [idForm, mail]);

	const loadPurchaseOrderByDocNum = useCallback(async (docNums) => {
		if (!Array.isArray(docNums) || docNums.length === 0) {
			setServiciosData([]);
			setProductosData([]);
			return;
		};

		const response = await fetch(apiurl + 'purchaseOrderByDocNum', {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				user: mail,
				sapDB,
				bilFormId: idForm
			}),
		});

		if (!response.ok) {
			throw new Error(`Error: ${response.status} ${response.statusText}`);
		}

		const data = await response.json();
		setServiciosData(data.servicios ?? []);
		setProductosData(data.productos ?? []);
		setCommentsFromOc(data.comments ?? []);
	}, [idForm, mail, sapDB]);

	useEffect(() => {
		setTableData(prev => ({ ...prev, comments: [...commentsFromOc?.map(c => c.comentario), invoice?.Comments].filter(Boolean).join('\n\n') }))
	}, [invoice, commentsFromOc])

	useEffect(() => {
		loadInvoice();
	}, [loadInvoice]);

	useEffect(() => {
		if (invoice?.order) {
			loadPurchaseOrderByDocNum(invoice.order)
		}
	}, [invoice, loadPurchaseOrderByDocNum]);

	useEffect(() => {
		if (!tableData.ordenCompra || tableData.ordenCompra.length === 0) {
			fetch(apiurl + 'queryAux', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					query: `
							select * from bil__line where bill = ${idForm}
							`,
					resu: 1, user: mail
				})
			}).then(async (response) => {
				if (response.ok) {
					const data = await response.json();
					const toSet =data?.map((x, y) => ({
						descripcion: x.name,
						cantidad: x.amount,
						cuentaContable: '',
						cc: '',
						costoNeto: x.cost,
						activoFijo: '',
						indice: y,
						freeText: '',
						TaxCode: x.TaxCode || 'IVA'
					})) ?? []
					setItemsFromXML(toSet.length === 0 ? [{
						descripcion: '', cantidad: '', cuentaContable: '', cc: '', costoNeto: '', activoFijo: '', indice: 0, freeText: '', TaxCode: 'IVA'
					}] : toSet)
				} else {
					console.error('Error al obtener las líneas sin OC');
				}
			}).catch((error) => {
				console.error('Error en la solicitud:', error);
			})

		}
	}, [tableData.ordenCompra, idForm, mail])

	const handleIngresadoChange = async (event) => {
		const newValue = event.target.value;
		setTableData((prev) => ({ ...prev, ingresado: newValue }));
		try {
			await updateInvoiceField('DocDate', newValue);
		} catch (error) {
			console.error('Error updating DocDate:', error);
		}
	};

	const handleContabilizadoChange = async (event) => {
		const newValue = event.target.value;
		setTableData((prev) => ({ ...prev, contabilizado: newValue }));
	}

	const handleVencimientoChange = useCallback(async (event) => {
		const newValue = event.target.value;
		setTableData((prev) => ({ ...prev, vencimiento: newValue }));
		try {
			await updateInvoiceField('DocDueDate', newValue);
		} catch (error) {
			console.error('Error updating DocDueDate:', error);
		}
	}, [updateInvoiceField]);

	const handleOpenOrderDialog = () => {
		const initialSelection = String(tableData.ordenCompra || '')
			.split(',')
			.map((value) => value.trim())
			.filter(Boolean);
		setSelectedOrderOptions(initialSelection);
		setShowOrderDialog(true);
	};

	const handleCancelOrderDialog = () => {
		setShowOrderDialog(false);
		setSelectedOrderOptions([]);
	};

	const handleAcceptOrderDialog = async (selectedOrders) => {
		setTableData((prev) => ({ ...prev, ordenCompra: selectedOrders }));
		try {
			setLineasSinOCForm(undefined);
			setSinOCInputsValidation([])
			await updateInvoiceField('`order`', selectedOrders);
			await loadPurchaseOrderByDocNum(selectedOrders);
			if (!selectedOrders ||selectedOrders.length === 0) {
				setCheckedProductos([]);
				setCheckedServicios([]);
				setCommentsFromOc([]);
			}
		} catch (error) {
			console.error('Error updating order from picker:', error);
		}
		handleCancelOrderDialog();
	};

	const validarLineasSinOC = useCallback(() => {
		let hasError = false;
		for (const linea of Array.isArray(lineasSinOCForm) ? lineasSinOCForm : []) {
			const error = {
				descripcion: !linea.descripcion || String(linea.descripcion).trim() === '',
				cantidad: !linea.cantidad || Number(linea.cantidad) <= 0,
				cuentaContable: !linea.cuentaContable || Number(linea.cuentaContable) <= 0,
				cc: !linea.cc || Number(linea.cc) <= 0
			};

			setSinOCInputsValidation(prev => [...prev.filter((e) => e.indice !== linea.indice), {...error, indice: linea.indice}]);
			if (Object.values(error).some((isError) => isError)) {
				hasError = true;
			}
		}

		return hasError
	}, [lineasSinOCForm, setSinOCInputsValidation]);

	const send = useCallback(async () => {
		if (lineasSinOCForm){
			const error = validarLineasSinOC()

			if (error) return
		}

		//alert(tableData.comments)

		if (isSending) return;
		const allCheckedItems = [...checkedServicios, ...checkedProductos];
		
		if (!tableData.ingresado) {
			alert('El campo "Ingresado" es obligatorio.');
			return
		}

		if (allCheckedItems.length === 0 && selectedOrderOptions.length !== 0) {
			alert('Debe seleccionar al menos una línea para incluir en la exportación.');
			return
		}

		try {
			setIsSending(true);
			const response = await fetch(apiurl + 'purchaseOrderSelectedLinesSave', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					sapDB,
					bilFormId: idForm,
					reqAprobacion: tableData.reqAprobacion,
					selectedLines: allCheckedItems,
					lineasSinOc: lineasSinOCForm,
					comments: tableData.comments.slice(0, MAX_COMMENTS_LENGTH),
					contabilizado: tableData.contabilizado ?? now.current,
				}),
			});

			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}

			const resp2 = await response.json();
			if (resp2.error === 0) {
				onClose(true);
			}else{
				alert('Error en la exportación: ' + (resp2.msg || 'Error desconocido'));
			}
		} catch (error) {
			console.error('Error sending selected lines:', error);
			alert('Error enviando líneas seleccionadas: ' + error.message);
		} finally {
			setIsSending(false);
		}
	}, [checkedServicios, checkedProductos, idForm, isSending, lineasSinOCForm, mail, onClose, sapDB, selectedOrderOptions.length, tableData.comments, tableData.ingresado, tableData.reqAprobacion, validarLineasSinOC, tableData.contabilizado]);

	const handleCheckedServicios = useCallback((selectedItems) => {
		setCheckedServicios(selectedItems);
	}, []);

	const handleCheckedProductos = useCallback((selectedItems) => {
		setCheckedProductos(selectedItems);
	}, []);

	const handleLineasSinOCFormChange = useCallback((lineData) => {
		setLineasSinOCForm((prev) => {
			const currentLines = Array.isArray(prev) ? prev : [];
			return [
				...currentLines.filter((linea) => linea.indice !== lineData.indice),
				lineData,
			];
		});
	}, []);

	const handleAddLineaSinOC = useCallback(() => {
		setItemsFromXML((prev) => {
			const currentItems = Array.isArray(prev) ? prev : [];
			const nextIndice = currentItems.reduce((max, item) => Math.max(max, item.indice), -1) + 1;
			return [
				...currentItems,
				{
					descripcion: '', cantidad: 0, cuentaContable: '', cc: '', costoNeto: 0,
					activoFijo: '', indice: nextIndice, freeText: '', TaxCode: 'IVA'
				},
			];
		});
	}, []);

	const handleDeleteLineaSinOC = useCallback((indice) => {
		if (Array.isArray(lineasSinOCForm) && lineasSinOCForm.length > 1 ) {
			setItemsFromXML((prev) => (Array.isArray(prev)
				? prev.filter((item) => item.indice !== indice)
				: []));
			setLineasSinOCForm((prev) => (Array.isArray(prev)
				? prev.filter((linea) => linea.indice !== indice)
				: []));
			setSinOCInputsValidation((prev) => (Array.isArray(prev)
				? prev.filter((validation) => validation.indice !== indice)
				: []));
		}
	}, [lineasSinOCForm]);

	return (
		<form>
			<orm-modal>
				<dialog open>
					<h2>Exportando a SAP</h2>
					{loading ? <p>Cargando datos...</p> : (
						<table>
							<tbody>
								<tr>
                                    <td>Ingresado</td>
									<td><input type="date" value={tableData.ingresado.split("T")[0] || ''} onChange={handleIngresadoChange} required /></td>
                                    <td>Contabilizado</td>
									<td><input type="datetime-local" value={tableData.contabilizado || ''} onChange={handleContabilizadoChange} required /></td>
									<td>Vencimiento</td>
									<td><input type="date" value={tableData.vencimiento || ''} onChange={handleVencimientoChange} /></td>
								</tr>
								<tr>
									<td>Neto</td>
									<td>
										<input className='disabled' type="text" value={fCurr(tableData.total - tableData.impuesto || 0)} readOnly />
									</td>
									<td>Impuesto</td>
									<td>
										<input className='disabled' type="text" value={fCurr(tableData.impuesto || 0)} readOnly />
									</td>
									<td>Total</td>
									<td>
										<input className='disabled' type="text" value={fCurr(tableData.total || 0)} readOnly />
									</td>
								</tr>
								<tr>
                                    <td>Proveedor</td>
									<td><input className='disabled' type="text" value={tableData.proveedor || ''} readOnly /></td>
									<td>Factura</td>
									<td><input className='disabled' type="text" value={String(tableData.factura || '')} readOnly /></td>
									<td>Orden de compra</td>
									<td><input type="text" value={tableData.ordenCompra || ''} onClick={handleOpenOrderDialog} readOnly className="order picker" /></td>
								</tr>
								<tr>
									<td>Req. aprobación</td>
									<td>
										<select value={tableData.reqAprobacion || 'N'} onChange={(e) => setTableData({ ...tableData, reqAprobacion: e.target.value })}>
											<option value="Y">Sí</option>
											<option value="N">No</option>
											<option value="P">Pagada</option>
											<option value="D">Borrador</option>
										</select>
									</td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
						</table>
					)}

					{
				serviciosData.length > 0 && <TableServicios itemsData={serviciosData} onCheckedItemsChange={handleCheckedServicios} total={total} showTotal={productosData.length === 0} />
			}
			{
				productosData.length > 0 && <TableProductos itemsData={productosData} onCheckedItemsChange={handleCheckedProductos} total={total} showTotal={true} />
			}
			{
				productosData.length ===	 0 && serviciosData.length === 0 && !loading && tableData.ordenCompra?.length === 0 &&
				<LineasSinOC
					itemsData={itemsFromXML}
					sinOCInputsValidation={sinOCInputsValidation}
					setLineasSinOCForm={handleLineasSinOCFormChange}
					deleteRow={handleDeleteLineaSinOC}
					addRow={handleAddLineaSinOC}
					total={total}
					showTotal={productosData.length ===	 0 && serviciosData.length === 0}
				/>
			}


					<h2>Comentarios</h2>
					<fieldset>
						<textarea
							value={tableData.comments}
							onChange={(e) => setTableData((prev) => ({ ...prev, comments: e.target.value }))}
						/>
						{tableData.comments?.length > 0 && (() => {
						const remaining = MAX_COMMENTS_LENGTH - tableData.comments.length;
							return remaining < 0
								? <p style={{ color: 'red', margin: '4px 0 0' }}>Quedan {remaining} carácteres. Los sobrantes no se mostrarán en SAP.</p>
								: <p style={{ margin: '4px 0 0' }}>Quedan {remaining} carácteres.</p>;
						})()}
					</fieldset>


			<table><tfoot><tr><td>
				  <input type="button" value="Cancelar" onClick={onClose} disabled={isSending}/>
				  <input type="button" value={isSending ? 'Enviando...' : 'Aceptar'} onClick={send} disabled={isSending}/>
				</td></tr></tfoot></table>

						<OrderPickerModal
							open={showOrderDialog}
							orders={purchaseOrders}
							initialSelectedOrders={selectedOrderOptions}
							onCancel={handleCancelOrderDialog}
							onAccept={handleAcceptOrderDialog}
						/>

				</dialog>
			</orm-modal>
		</form>
	);

}


function TableServicios({ itemsData, onCheckedItemsChange, total, showTotal }) {
	const [includeByIndex, setIncludeByIndex] = useState({});

	useEffect(() => {
		const initialState = (itemsData || []).reduce((acc, _, idx) => {
			acc[idx] = false;
			return acc;
		}, {});
		setIncludeByIndex(initialState);
	}, [itemsData]);

	useEffect(() => {
		const selectedItems = (itemsData || [])
			.filter((_, idx) => Boolean(includeByIndex[idx]))
			.map((item) => ({
				...item?.documentoLinea,
				baseType: 22,
				cantidad: item.cantidad,
				costoNeto: item.costoNeto
			}))
			.filter((doc) => doc && doc.numeroLinea !== undefined);
		if (typeof onCheckedItemsChange === 'function') {
			onCheckedItemsChange(selectedItems);
		}
	}, [includeByIndex, itemsData, onCheckedItemsChange]);

	return <>
		<h2>Líneas incluidas</h2>
		<table>
			<tbody>
				<td>Código</td>
				<td>Artículo</td>
				<td>Cantidad</td>
				<td>Costo neto</td>
				<td>Cuenta</td>
				<td>CC</td>
				<td>Incluir</td>
				{(itemsData || []).map((item, idx) => {
					return (
						<tr key={`${item.codigo}-${idx}`}>
							<td>{item.codigo}</td>
							<td>
								<h3>{item.articulo}</h3>
								<div>{item.articuloSub}</div>
							</td>
							<td>{item.cantidad}</td>
							<td style={{textAlign: "right"}}>{fCurr(item.costoNeto)}</td>
							<td>{item.cuenta}</td>
							<td>{item.cc}</td>
							<td>
								<input
									type="checkbox"
									checked={Boolean(includeByIndex[idx])}
									onChange={(e) => {
										const checked = e.target.checked;
										setIncludeByIndex((prev) => ({ ...prev, [idx]: checked }));
									}}
								/>
							</td>
						</tr>
					);
				})}
			</tbody>
				{ showTotal &&
						<tfoot>
            		  <tr>
            		    <td></td>
            		    <td></td>
            		    <th>Total:</th>
            		    <th id="total">{fCurr(total)}</th>
            		    <td></td>
            		    <td></td>
            		    <td></td>
            		    <td></td>
            		  </tr>
            		</tfoot>
				}
		</table>
	</>
}

function TableProductos({ itemsData, onCheckedItemsChange, total, showTotal }) {
	const [includeByIndex, setIncludeByIndex] = useState({});
	const [costoNetoByIndex, setCostoNetoByIndex] = useState({});

	useEffect(() => {
		const initialState = (itemsData || []).reduce((acc, _, idx) => {
			acc[idx] = false;
			return acc;
		}, {});
		setIncludeByIndex(initialState);

		setCostoNetoByIndex((itemsData || []).reduce((acc, item, idx) => {
			acc[idx] = item['costoNeto'] || 0;
			return acc;
		}, {}));
	}, [itemsData]);

	useEffect(() => {
		const selectedItems = (itemsData || [])
			.flatMap((item, idx) => 
				(item?.documentoLinea ? [item.documentoLinea] : []).map((doc) => ({
					...doc,
					baseType: 20,
					cantidad: item.cantidad,
					costoNeto: Number(costoNetoByIndex[idx]),
				}))
			)
			.filter((_, idx) => Boolean(includeByIndex[idx]))
			.filter((doc) => doc && doc.numeroLinea !== undefined);
		if (typeof onCheckedItemsChange === 'function') {
			onCheckedItemsChange(selectedItems);
		}
	}, [includeByIndex, itemsData, onCheckedItemsChange, costoNetoByIndex]);

	const handleCheckboxChange = useCallback((idx, checked) => {
		const currentItem = itemsData?.[idx];
		if (!currentItem) return;

		const currentEntrada = currentItem.entrada;
		const newIncludeState = { ...includeByIndex, [idx]: checked };

		// Encontrar todos los índices con la misma entrada
		(itemsData || []).forEach((item, itemIdx) => {
			if (item.entrada === currentEntrada) {
				newIncludeState[itemIdx] = checked;
			}
		});

		setIncludeByIndex(newIncludeState);
	}, [itemsData, includeByIndex]);

	return (
		<>
			<h2>Líneas incluidas</h2>
			<table>
				<tbody>
					<tr>
						<td>Entrada</td>
						<td>Ingresado</td>
						<td>Línea</td>
						<td>Cantidad</td>
						<td>Costo neto</td>
						<td>Cuenta</td>
						<td>CC</td>
						<td>Incluir</td>
					</tr>
					{(itemsData || []).map((item, idx) => (
						<tr key={`${item.entrada}-${idx}`}>
							<td>{item.entrada}</td>
							<td>{item.ingresado}</td>
							<td>{item.documentoLinea.numeroLinea}</td>
							<td>{item.cantidad}</td>
							<td>
								<input style={{textAlign: "right", maxWidth: "20px"}} type="number"
								value={costoNetoByIndex[idx]}
								onChange={x => setCostoNetoByIndex(prev => ({...prev, [idx]: x.target.value}))}
								></input>
							</td>
							{/*
							<td style={{textAlign: "right"}}>{item['Costo neto']}</td>
							*/}
							<td>{item.cuenta}</td>
							<td>{item.cc}</td>
							<td>
								<input
									type="checkbox"
									checked={Boolean(includeByIndex[idx])}
									onChange={(e) => handleCheckboxChange(idx, e.target.checked)}
								/>
							</td>
						</tr>
					))}
				</tbody>
				{ showTotal &&
						<tfoot>
            		  <tr>
            		    <td></td>
            		    <td></td>
            		    <td></td>
            		    <th>Total:</th>
            		    <th id="total">{fCurr(total)}</th>
            		    <td></td>
            		    <td></td>
            		    <td></td>
            		  </tr>
            		</tfoot>
				}
			</table>
		</>
	);
}

function OrderPickerModal({ open, orders, initialSelectedOrders, onCancel, onAccept }) {
	const [selectedMap, setSelectedMap] = useState({});
	const [sinOC, setSinOC] = useState(false);

	useEffect(() => {
		if (!open) return;

		const nextSelectedMap = (initialSelectedOrders || []).reduce((acc, docNum) => {
			if (orders && orders.some((order) => String(order.docNum) === String(docNum))) {
				acc[String(docNum)] = true;
			}

			return acc;
		}, {});

		setSelectedMap(nextSelectedMap);
	}, [initialSelectedOrders, open, orders]);

	useEffect(() =>{
		if (sinOC) {
			setSelectedMap({});
		}
	}, [sinOC])

	useEffect(()=>{
		if (Object.keys(selectedMap).filter((key) => selectedMap[key]).length > 0) {
			setSinOC(false);
		}else{
			setSinOC(true);
		}
	}, [selectedMap])

	if (!open) {
		return null;
	}

	return (
		<orm-modal>
			<dialog id="orderDialog" open>
				<h2>Órdenes de compra</h2>
				<fieldset className="scroll">
					<legend>
						{orders && orders.length > 0 ? orders[0].CardName : ''}
					</legend>
				<table>
					<tbody>
						<tr>
							<td>
								<input
									type="checkbox"
									checked={sinOC}
									onChange={(event) => {
										const checked = event.target.checked;
										if (Object.keys(selectedMap).filter((key) => !selectedMap[key]).length === 0 && sinOC)
											return

										setSinOC(checked);
									}}
								/>
							</td>
							<td>Sin OC</td>
							<td></td>
							<td></td>
							<td></td>
						</tr>

						{(orders || []).map((order) => {
							const docNum = String(order.docNum ?? '').trim();
							return (
								<tr key={docNum}>
									<td>
										<input
											type="checkbox"
											checked={Boolean(selectedMap[docNum])}
											onChange={(event) => {
												const checked = event.target.checked;
												setSelectedMap((prev) => ({ ...prev, [docNum]: checked }));
											}}
										/>
									</td>
									<td>{`OC ${docNum}`}</td>
									<td>{String(order.date || '').split('-').reverse().join('/')}</td>
									<td>{order.paymentTerm}</td>
									<td style={{ textAlign: 'right' }}>{Number(order.netoTotal).toLocaleString('es-CL')} CLP</td>
									<td>
										{
											order.from === "PurchaseOrders" ?
												"Sin EM."
											:
											order.from === "PurchaseDeliveryNotes" ?
												`${order.emCount} EM (` + Number(order.emTotal).toLocaleString('es-CL') + ' CLP)'
											:
											"Error" + order.from
										}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
				</fieldset>
				<table>
					<tfoot>
						<tr>
							<td>
								<input type="button" value="Cancelar" onClick={onCancel} />
								<input
									type="button"
									value="Aceptar"
									onClick={() => {
										const selectedOrders = Object.keys(selectedMap).filter((docNum) => selectedMap[docNum]).map(Number);
										onAccept(selectedOrders);
									}}
								/>
							</td>
						</tr>
					</tfoot>
				</table>
			</dialog>
		</orm-modal>
	);
}

function LineasSinOC({ itemsData, sinOCInputsValidation, setLineasSinOCForm, deleteRow, addRow, total, showTotal }) {
	const [accounts, setAccounts] = useState([]);
	const [costCenters, setCostCenters] = useState([]);
	const canDeleteRows = (itemsData || []).length > 1;

	useEffect(() => {
		let cancelled = false;

		const loadAccounts = async () => {
			try {
				const response = await fetch(apiurl + 'invo/sysAcct');
				if (!response.ok) {
					throw new Error(`Error: ${response.status} ${response.statusText}`);
				}

				const result = await response.json();
				if (!cancelled) {
					setAccounts(Array.isArray(result) ? result : []);
				}
			} catch (error) {
				console.error('Error fetching sysAcct:', error);
			}
		};

		loadAccounts();

		return () => {
			cancelled = true;
		};
	}, []);

	useEffect(() => {
		let cancelled = false;

		const loadCostCenters = async () => {
			try {
				const response = await fetch(apiurl + 'invo/sysCC');
				if (!response.ok) {
					throw new Error(`Error: ${response.status} ${response.statusText}`);
				}

				const result = await response.json();
				if (!cancelled) {
					setCostCenters(Array.isArray(result) ? result : []);
				}
			} catch (error) {
				console.error('Error fetching sysCC:', error);
			}
		};

		loadCostCenters();

		return () => {
			cancelled = true;
		};
	}, []);

	return <>
		<h2>Líneas incluidas</h2>
		<table>
			<tbody>
				<tr>
					<td>Descripción</td>
					<td>Cantidad</td>
					<td>Costo neto</td>
					<td>Exento</td>
					<td>Cuenta</td>
					<td>CC</td>
					<td>Texto libre</td>
					<td>Activo Fijo</td>
				</tr>
				{(itemsData || []).map((item) => (
					<LineasSinOCRow
						key={item.indice}
						defaultData={item}
						sinOCInputsValidation={Array.isArray(sinOCInputsValidation)
							? sinOCInputsValidation.find((validation) => validation.indice === item.indice)
							: sinOCInputsValidation}
						setLineasSinOCForm={setLineasSinOCForm}
						deleteRow={deleteRow}
						accounts={accounts}
						costCenters={costCenters}
						canDeleteRow={canDeleteRows}
					/>
				))}
			</tbody>
			{ showTotal &&
					<tfoot>
					  <tr>
					    <td></td>
					    <th>Total:</th>
					    <th id="total">{fCurr(Math.round(total))}</th>
					    <td></td>
					    <td></td>
					    <td></td>
					    <td></td>
					    <td colSpan={2}><input type="button" value="+ Agregar línea" onClick={addRow} /></td>
					  </tr>
					</tfoot>
			}
		</table>
	</>
}

function LineasSinOCRow({sinOCInputsValidation, setLineasSinOCForm, defaultData, deleteRow, accounts, costCenters, canDeleteRow}) {
	const [data, setData] = useState({
		descripcion: defaultData?.descripcion || '',
		cantidad: defaultData?.cantidad || '',
		cuentaContable: defaultData?.cuentaContable || '',
		cc: defaultData?.cc || '',
		costoNeto: defaultData?.costoNeto || '',
		activoFijo: defaultData?.activoFijo || '',
		indice: defaultData?.indice || 0,
		freeText: defaultData?.freeText || '',
		TaxCode: defaultData?.TaxCode || ''
	});
	const [accountSearch, setAccountSearch] = useState('');
	const [ccSearch, setCcSearch] = useState('');
	const [viewCostoNetoDecimal, setViewCostoNetoDecimal] = useState(false);
	const [viewCantidadDecimal, setViewCantidadDecimal] = useState(false);

	const normalizeAccountText = useCallback((value) => (
		String(value ?? '')
			.toLowerCase()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.trim()
	), []);

	const findMatchingAccount = useCallback((value) => {
		const normalizedValue = normalizeAccountText(value);
		if (!normalizedValue) return undefined;

		return accounts.find((account) => {
			const code = String(account?.code ?? '').trim();
			const name = String(account?.name ?? '').trim();
			return [
				normalizeAccountText(code),
				normalizeAccountText(name),
				normalizeAccountText(`${code} ${name}`),
			].includes(normalizedValue);
		});
	}, [accounts, normalizeAccountText]);

	const findAccountBySearchTokens = useCallback((value) => {
		const normalizedValue = normalizeAccountText(value);
		if (!normalizedValue) return undefined;

		const tokens = normalizedValue.split(/\s+/).filter(Boolean);
		if (tokens.length === 0) return undefined;

		const matches = accounts.filter((account) => {
			const searchableText = normalizeAccountText(`${account?.code} ${account?.name}`);
			return tokens.every((token) => searchableText.includes(token));
		});

		return matches.length === 1 ? matches[0] : undefined;
	}, [accounts, normalizeAccountText]);

	const selectedAccount = accounts.find((account) => String(account?.code ?? '') === String(data.cuentaContable ?? ''));
	const selectedCostCenter = costCenters.find((costCenter) => String(costCenter?.code ?? '') === String(data.cc ?? ''));

	const filteredAccounts = accounts.filter((account) => {
		const normalizedSearch = normalizeAccountText(accountSearch);
		if (!normalizedSearch) return true;

		const searchableText = normalizeAccountText(`${account?.code} ${account?.name}`);
		return normalizedSearch.split(/\s+/).every((token) => searchableText.includes(token));
	});

	const accountOptions = filteredAccounts.flatMap((account) => {
		const code = String(account?.code ?? '').trim();
		const name = String(account?.name ?? '').trim();

		return code ? [{ key: code, value: code, label: name }] : [];
	});

	const findMatchingCostCenter = useCallback((value) => {
		const normalizedValue = normalizeAccountText(value);
		if (!normalizedValue) return undefined;

		return costCenters.find((costCenter) => {
			const code = String(costCenter?.code ?? '').trim();
			const name = String(costCenter?.name ?? '').trim();
			return [
				normalizeAccountText(code),
				normalizeAccountText(name),
				normalizeAccountText(`${code} ${name}`),
			].includes(normalizedValue);
		});
	}, [costCenters, normalizeAccountText]);

	const findCostCenterBySearchTokens = useCallback((value) => {
		const normalizedValue = normalizeAccountText(value);
		if (!normalizedValue) return undefined;

		const tokens = normalizedValue.split(/\s+/).filter(Boolean);
		if (tokens.length === 0) return undefined;

		const matches = costCenters.filter((costCenter) => {
			const searchableText = normalizeAccountText(`${costCenter?.code} ${costCenter?.name}`);
			return tokens.every((token) => searchableText.includes(token));
		});

		return matches.length === 1 ? matches[0] : undefined;
	}, [costCenters, normalizeAccountText]);

	const filteredCostCenters = costCenters.filter((costCenter) => {
		const normalizedSearch = normalizeAccountText(ccSearch);
		if (!normalizedSearch) return true;

		const searchableText = normalizeAccountText(`${costCenter?.code} ${costCenter?.name}`);
		return normalizedSearch.split(/\s+/).every((token) => searchableText.includes(token));
	});

	const costCenterOptions = filteredCostCenters.flatMap((costCenter) => {
		const code = String(costCenter?.code ?? '').trim();
		const name = String(costCenter?.name ?? '').trim();

		return code ? [{ key: code, value: code, label: name }] : [];
	});

	const handleChange = (name, value) => {
		setData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const resolveAccountSearch = useCallback((value) => {
		const normalizedValue = String(value ?? '').trim();

		if (!normalizedValue) {
			setAccountSearch('');
			handleChange('cuentaContable', '');
			return;
		}

		const matchedAccount = findMatchingAccount(normalizedValue) ?? findAccountBySearchTokens(normalizedValue);
		if (!matchedAccount) {
			setAccountSearch(normalizedValue);
			handleChange('cuentaContable', '');
			return;
		}

		const code = String(matchedAccount.code ?? '');
		setAccountSearch(code);
		handleChange('cuentaContable', code);
	}, [findAccountBySearchTokens, findMatchingAccount]);

	const handleAccountSearchChange = useCallback((value) => {
		setAccountSearch(value);

		if (!String(value ?? '').trim()) {
			handleChange('cuentaContable', '');
		}
	}, []);

	const resolveCcSearch = useCallback((value) => {
		const normalizedValue = String(value ?? '').trim();

		if (!normalizedValue) {
			setCcSearch('');
			handleChange('cc', '');
			return;
		}

		const matchedCostCenter = findMatchingCostCenter(normalizedValue) ?? findCostCenterBySearchTokens(normalizedValue);
		if (!matchedCostCenter) {
			setCcSearch(normalizedValue);
			handleChange('cc', '');
			return;
		}

		const code = String(matchedCostCenter.code ?? '');
		setCcSearch(code);
		handleChange('cc', code);
	}, [findCostCenterBySearchTokens, findMatchingCostCenter]);

	const handleCcSearchChange = useCallback((value) => {
		setCcSearch(value);

		if (!String(value ?? '').trim()) {
			handleChange('cc', '');
		}
	}, []);

	useEffect(() => {
		setLineasSinOCForm(data);
	}, [data, setLineasSinOCForm]);

	return <tr>
		<td><input className={sinOCInputsValidation?.descripcion ? 'error' : ''} type="text" value={data.descripcion} title={data.descripcion} onChange={(e) => handleChange('descripcion', e.target.value)} /></td>
		<td>
			<input className={sinOCInputsValidation?.cantidad ? 'error' : ''} type={viewCantidadDecimal ? 'number' : 'text'} value={viewCantidadDecimal === true ? data.cantidad : (Number.isNaN(parseFloat(data.cantidad)) ? '' : Math.round(parseFloat(data.cantidad)))} onChange={(e) => handleChange('cantidad', e.target.value)}
				onFocus={()=> setViewCantidadDecimal(true)}
				onBlur={()=> setViewCantidadDecimal(false)}
			/>
		</td>
		<td>
			<input type={viewCostoNetoDecimal ? 'number' : 'text'} value={viewCostoNetoDecimal === true ? data.costoNeto : (Number.isNaN(parseFloat(data.costoNeto)) ? '' : Math.round(parseFloat(data.costoNeto)))} onChange={(e) => handleChange('costoNeto', e.target.value)}
				onFocus={()=> setViewCostoNetoDecimal(true)}
				onBlur={()=> setViewCostoNetoDecimal(false)}
			/>
		</td>
		<td>
			<input type="checkbox" checked={data.TaxCode === 'IVA_EXE'} onChange={(e) => handleChange('TaxCode', e.target.checked ? 'IVA_EXE' : 'IVA')} />
		</td>
		<td>
			<input
				className={sinOCInputsValidation?.cuentaContable ? 'error' : ''}
				type="search"
				list={`sys-acct-options-${data.indice}`}
				value={accountSearch}
				title={selectedAccount?.name || ''}
				onChange={(e) => handleAccountSearchChange(e.target.value)}
				onBlur={(e) => resolveAccountSearch(e.target.value)}
			/>
			<datalist id={`sys-acct-options-${data.indice}`}>
				{accountOptions.map((accountOption) => (
					<option key={accountOption.key} value={accountOption.value}>
						{accountOption.label}
					</option>
				))}
			</datalist>
		</td>
		<td>
			<input
				className={sinOCInputsValidation?.cc ? 'error' : ''}
				type="search"
				list={`sys-cc-options-${data.indice}`}
				value={ccSearch}
				title={selectedCostCenter?.name || ''}
				onChange={(e) => handleCcSearchChange(e.target.value)}
				onBlur={(e) => resolveCcSearch(e.target.value)}
			/>
			<datalist id={`sys-cc-options-${data.indice}`}>
				{costCenterOptions.map((costCenterOption) => (
					<option key={costCenterOption.key} value={costCenterOption.value}>
						{costCenterOption.label}
					</option>
				))}
			</datalist>
		</td>
		<td><input type="text" value={data.freeText} onChange={(e) => handleChange('freeText', e.target.value)} title={data.freeText} /></td>
		<td><input type="text" value={data.activoFijo} onChange={(e) => handleChange('activoFijo', e.target.value)} /></td>
		<td>{canDeleteRow ? <button type="button" onClick={() => deleteRow(data.indice)}></button> : null}</td>
	</tr>
}

export default ExpoBillSap
